// import React, { useState } from 'react';

const AuthButton = (props) => {
    // const [password, setpassword] = useState("");
    // const [forgotpassword, setforgotpassword] = useState(false);
    // const [passwordvisible, setpasswordvisible] = useState(false);
    return (
        <button
            type="submit"
            disabled={props?.loading || props?.disabled}
            onClick={props.onClick}
            // className={props.className}
            className={`w-${props?.width ? props?.width : 'full'} max-w-sm flex items-center justify-center gap-x-2 py-2 text-sm bg-[#361D32] text-black rounded-md font-semibold mb-4 ${props?.className}  ${props?.loading || props?.disabled ? "bg-gray-400 cursor-not-allowed" : ""} `}
        >
            {props?.loading && <span className="loader border-2 border-t-transparent border-white w-4 h-4 inline-flex rounded-full animate-spin"></span>}
            {props?.title}
        </button>

    );
};

export default AuthButton;
